class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '1e0f85b2';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1140.0.2';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 12 Nov 2025 15:11:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2025-11-12 10:11:12 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2025-11-12 10:11:12 Boston - 1e0f85b2 - 1140.0.2';
export default BuildTags;
